import React from "react";
import Button from "@mui/material/Button";

interface ownProps {
  variant?: "contained" | "outlined" | "text";
  name: string;
  buttonType?: "button" | "submit" | "reset" | undefined;
  onClick?: () => void;
  sx?: any;
  disabled?: boolean;
}
const ButtonComponent: React.FC<ownProps> = ({
  variant,
  name,
  buttonType,
  sx,
  onClick,
  disabled,
}: ownProps) => {
  return (
    <Button
      disabled={disabled}
      sx={sx}
      onClick={onClick}
      variant={variant}
      type={buttonType}
    >
      {name}{" "}
    </Button>
  );
};

export default ButtonComponent;
